import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import {SelectMesContabilidad} from 'sharedComponents/select'

const MesContabilidadFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MES' htmlFor='input-mesContabilidad' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='mes'>
          {({ field }) => (
            <SelectMesContabilidad id="select-mesContabilidad" fIsSubmitting={fIsSubmitting} iError={iError} iTouched={iTouched} {...field} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MesContabilidadFormGroup)
